export const generatedCompositeId = row => {
  if (row?.activityPlanId && row?.activityRealId) {
    return `${row?.activityPlanId}-${row?.activityRealId}`;
  }
  if (row?.activityPlanId) {
    return `${row?.activityPlanId}-plan`;
  }
  if (row?.activityDiverseId) {
    return `${row?.activityDiverseId}-div`;
  }
  return `${row?.activityRealId}-real`;
};
